'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import Script from 'next/script'

export default function DynamicScriptLoader({
  scripts,
  language,
}: {
  scripts: Array<{
    src: string
    type?: string
    dataDomainScript?: string
    dataDocumentLanguage?: boolean
  }>
  language: string
}) {
  const router = useRouter()
  useEffect(() => {
    const prevLanguage = localStorage.getItem('prevLanguage')
    localStorage.setItem('prevLanguage', language)

    if (prevLanguage && prevLanguage !== language) {
      // reset the page to the new language
      // window.location.reload();
      router.refresh()
    }
  }, [language])

  return (
    <>
      {scripts.map((script, index) => (
        <Script
          key={index}
          src={script.src}
          type={script.type}
          data-domain-script={script.dataDomainScript}
          data-document-language={script.dataDocumentLanguage}
        />
      ))}
    </>
  )
}
